// Minimal ImageKit loader for Next/Image using remote URL fetching
// Usage: <Image loader={imageKitLoader} src={fullSourceUrl} ... />
// Requires NEXT_PUBLIC_IMAGEKIT_URL_ENDPOINT to be set, e.g., https://ik.imagekit.io/your_id

export const imageKitLoader = ({ src, width, quality }) => {
  try {
    const endpoint = process.env.NEXT_PUBLIC_IMAGEKIT_URL_ENDPOINT;
    if (!endpoint || !src) return src;

    const tr = [`w-${width || 800}`];
    if (quality) tr.push(`q-${quality}`);

    // Build ImageKit "fetch" URL that proxies the original absolute URL
    // Doc: https://docs.imagekit.io/features/transformations/url-based#using-external-urls
    const encodedSrc = encodeURIComponent(src);
    return `${endpoint}/tr:${tr.join(',')}/${encodedSrc}`;
  } catch (e) {
    return src;
  }
};

export default imageKitLoader;

